import Common from "../../../Common";

// TODO: Fix update/create body type

const User = class extends Common {
	// @ts-expect-error please i just want to build this project
	async browse(companyId: id): CustomResponse<PbxUser[]> {
		return this.get(`/company/${companyId}/pbx/user`);
	}

	async read(companyId: id, userId: id) {
		return this.get(`/company/${companyId}/pbx/user/${userId}`)
	}

	async update(companyId: id, userId: id, body: any) {
		return this.patch(`/company/${companyId}/pbx/user/${userId}`, body)
	}

	async resetPassword(companyId: id, userId: id, data: {to: string}) {
		return this.post(`/company/${companyId}/pbx/user/${userId}/resetpassword`, data)
	}

	async create(companyId: id, body: any) {
		return this.post(`/company/${companyId}/pbx/user`, body)
	}

	async delete(companyId: id, userId: id) {
		return this.doDelete(`/company/${companyId}/pbx/user/${userId}`)
	}

	async getDestinations(companyId: id, userId: id) {
		return this.get(`/company/${companyId}/pbx/userdestinations/${userId}`)
	}

	async welcomeMail(companyId: id, userIds: string[]) {
		return this.post(`/company/${companyId}/pbx/user/welcome`, { userIds })
	}
}

export default User;
